import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useAuth } from "@/lib/auth.jsx";
import { api } from "@/lib/api";
import { getLocalProgress } from "@/lib/progress";

const destFrom = (lp) => {
  if (!lp) return null;
  if (lp.pending_quiz) return "/auth?next=/dashboard";
  if (lp.last_route && !["/", "/auth"].includes(lp.last_route)) return lp.last_route;
  const answered = lp.answers && Object.keys(lp.answers).length > 3;
  if ((typeof lp.step === "number" && lp.step > 0) || answered) return "/quiz";
  return null;
};

export default function ResumeBanner() {
  const { user, loading } = useAuth();
  const [dest, setDest] = useState(() => destFrom(getLocalProgress()));

  useEffect(() => {
    if (loading) return;
    let alive = true;
    (async () => {
      if (user) {
        try {
          const { data } = await api.get("/resume");
          if (alive) setDest(data.destination && data.destination !== "/" ? data.destination : null);
          return;
        } catch { /* fall through to local */ }
      }
      if (alive) setDest(destFrom(getLocalProgress()));
    })();
    return () => { alive = false; };
  }, [user, loading]);

  if (!dest) return null;

  return (
    <div className="max-w-5xl mx-auto px-5 pt-4" data-testid="resume-banner">
      <Link
        to={dest}
        className="flex items-center justify-between gap-3 rounded-lg border border-[#FD0F10]/50 bg-[#FD0F10]/10 px-4 py-3 hover:bg-[#FD0F10]/15 transition-colors"
        data-testid="resume-banner-continue"
      >
        <div className="min-w-0">
          <div className="eyebrow text-[#FD0F10]">WELCOME BACK</div>
          <div className="text-sm sm:text-base text-white font-bold leading-snug truncate">Pick up where you left off</div>
        </div>
        <span className="shrink-0 flex items-center gap-1.5 hero-accent text-white text-xs font-mono-ui uppercase tracking-wider px-3.5 py-2 rounded">
          Continue <ArrowRight size={14} />
        </span>
      </Link>
    </div>
  );
}
